// extracted by mini-css-extract-plugin
module.exports = {"modal":"modal--2Nbi1NToD","is_medium":"is_medium--1aV3rHsnH"};